export const navLinks = [
  { label: '首页', href: '/' },
  { label: '功能分类', href: '/categories' },
  { label: '文章资讯', href: '/articles' },
  { label: '关于我们', href: '/about' },
];

export const heroData = {
  title: '91浏览器',
  subtitle: '极速 · 安全 · 智能',
  description: '新一代高性能浏览器，为您带来前所未有的网页浏览体验。内置广告拦截、隐私保护、智能加速引擎，让每一次点击都快人一步。',
  primaryButton: '立即下载',
  secondaryButton: '了解更多',
  primaryHref: '#download',
  secondaryHref: '#features',
};

export const featureCategories = [
  {
    id: 'speed',
    name: '极速浏览',
    icon: 'ri-flashlight-line',
    description: '采用新一代浏览器内核，页面加载速度提升300%，流畅应对各类复杂网页。',
  },
  {
    id: 'security',
    name: '安全防护',
    icon: 'ri-shield-check-line',
    description: '多层安全防护体系，实时拦截恶意网站与钓鱼链接，守护您的上网安全。',
  },
  {
    id: 'privacy',
    name: '隐私保护',
    icon: 'ri-eye-close-line',
    description: '无痕浏览模式、智能反追踪技术，全方位保护您的个人隐私数据。',
  },
  {
    id: 'adblock',
    name: '广告拦截',
    icon: 'ri-forbid-2-line',
    description: '智能广告过滤引擎，自动拦截弹窗广告和视频贴片广告，还您清爽页面。',
  },
  {
    id: 'multitab',
    name: '多标签管理',
    icon: 'ri-layout-grid-line',
    description: '强大的标签页管理功能，支持标签分组、批量操作，多任务切换更高效。',
  },
  {
    id: 'sync',
    name: '跨设备同步',
    icon: 'ri-refresh-line',
    description: '书签、密码、历史记录云端同步，无缝切换手机与电脑，数据随身携带。',
  },
];

export const highlights = [
  {
    value: '5亿+',
    label: '全球用户',
    icon: 'ri-user-line',
  },
  {
    value: '99.9%',
    label: '可用性保障',
    icon: 'ri-check-double-line',
  },
  {
    value: '300%',
    label: '速度提升',
    icon: 'ri-speed-up-line',
  },
  {
    value: '1000万+',
    label: '日均拦截广告',
    icon: 'ri-shield-flash-line',
  },
];

export const features = [
  {
    title: '智能预加载引擎',
    description: '基于AI算法预测用户浏览行为，提前加载目标页面内容，实现秒开级的网页加载体验。无论是新闻资讯、视频网站还是在线办公，都能感受到丝滑流畅的操作体验。',
    icon: 'ri-rocket-2-line',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20flowing%20orange%20and%20warm%20gradient%20lines%20representing%20high%20speed%20data%20transfer%20in%20a%20minimalist%20digital%20space%2C%20clean%20white%20background%20with%20dynamic%20motion%20streaks%2C%20modern%20tech%20aesthetic%2C%20no%20blue%20or%20purple%20colors%2C%20warm%20coral%20and%20golden%20accents%2C%20artistic%20abstract%20visualization%20of%20speed&width=800&height=500&seq=feature-speed-01&orientation=landscape',
  },
  {
    title: '全方位安全防护',
    description: '集成智能反钓鱼数据库与实时恶意网址检测引擎，自动识别并拦截危险链接。支持HTTPS强制加密连接，确保您的网络通信始终受到保护，让每一次浏览都安心无忧。',
    icon: 'ri-shield-keyhole-line',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20shield%20concept%20with%20warm%20golden%20and%20coral%20geometric%20shapes%20on%20clean%20white%20background%2C%20representing%20digital%20security%20and%20protection%2C%20soft%20glowing%20edges%2C%20modern%20tech%20aesthetic%2C%20no%20blue%20or%20purple%2C%20warm%20teal%20and%20orange%20accents&width=800&height=500&seq=feature-security-02&orientation=landscape',
  },
  {
    title: '隐私保护中心',
    description: '提供精细化的隐私设置面板，支持按网站分别配置Cookie策略、追踪权限和JavaScript执行规则。无痕模式下所有浏览记录自动清除，让隐私真正做到滴水不漏。',
    icon: 'ri-fingerprint-line',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm-toned%20digital%20privacy%20concept%20with%20layered%20translucent%20geometric%20shapes%20and%20soft%20glowing%20nodes%20on%20clean%20minimal%20background%2C%20representing%20data%20protection%2C%20no%20blue%20or%20purple%2C%20coral%20and%20amber%20warm%20accents%2C%20artistic%20tech%20visualization&width=800&height=500&seq=feature-privacy-03&orientation=landscape',
  },
];

export const platforms = [
  {
    name: 'Windows',
    icon: 'ri-windows-line',
    version: 'v12.4.0',
    size: '128 MB',
    description: '支持 Windows 10 / 11',
    href: '#download-windows',
  },
  {
    name: 'macOS',
    icon: 'ri-apple-line',
    version: 'v12.4.0',
    size: '145 MB',
    description: '支持 macOS 12+',
    href: '#download-macos',
  },
  {
    name: 'Android',
    icon: 'ri-android-line',
    version: 'v12.4.0',
    size: '68 MB',
    description: '支持 Android 8.0+',
    href: '#download-android',
  },
  {
    name: 'iOS',
    icon: 'ri-smartphone-line',
    version: 'v12.4.0',
    size: '82 MB',
    description: '支持 iOS 15+',
    href: '#download-ios',
  },
];

export const faqs = [
  {
    question: '91浏览器是免费的吗？',
    answer: '是的，91浏览器完全免费使用。我们承诺不会向个人用户收取任何费用，所有核心功能均可免费使用。我们通过企业级服务和技术授权来维持运营，确保个人用户始终享受免费的优质浏览体验。',
  },
  {
    question: '91浏览器如何保护我的隐私？',
    answer: '91浏览器采用多重隐私保护技术：内置智能反追踪引擎阻止第三方跟踪器收集您的浏览数据；无痕浏览模式下所有浏览记录、Cookie和表单数据自动清除；支持按站点配置隐私策略，灵活控制每个网站的权限。',
  },
  {
    question: '91浏览器支持哪些平台？',
    answer: '91浏览器全面支持Windows、macOS、Android和iOS四大主流平台。您可以在官网下载对应平台的安装包，所有平台均支持书签、密码和历史记录的跨设备云同步功能。',
  },
  {
    question: '如何导入其他浏览器的书签和密码？',
    answer: '安装91浏览器后，首次启动时会自动检测您设备上已安装的其他浏览器，并提供一键导入书签、密码和历史记录的选项。您也可以随时在设置菜单中的"导入数据"功能中手动选择导入。',
  },
  {
    question: '91浏览器的广告拦截功能如何使用？',
    answer: '91浏览器默认开启智能广告拦截功能，您无需任何设置即可享受清爽的浏览体验。如需自定义拦截规则，可以在设置中心的"广告拦截"选项中添加白名单网站或调整拦截强度。',
  },
  {
    question: '91浏览器会收集我的哪些数据？',
    answer: '我们始终坚持"最小化数据收集"原则。91浏览器仅收集必要的匿名化崩溃诊断数据和匿名的使用统计信息来改进产品，绝不收集您的浏览历史、搜索记录或个人身份信息。详细内容请查阅我们的隐私政策。',
  },
];

export const seoContent = {
  sections: [
    {
      heading: '为什么选择91浏览器？',
      content: '在当今数字化时代，选择一款优秀的浏览器至关重要。91浏览器凭借其卓越的极速浏览体验、全方位的安全防护能力和智能化的隐私保护系统，已经成为全球5亿用户信赖的网页浏览工具。无论是日常网页浏览、在线办公还是娱乐影音，91浏览器都能为您提供稳定流畅的使用体验。',
    },
    {
      heading: '91浏览器的核心优势',
      content: '91浏览器采用新一代浏览器内核引擎，页面加载速度相比传统浏览器提升300%，同时大幅降低内存占用。内置智能广告拦截功能可以有效过滤弹窗广告和视频贴片广告，提升页面加载速度的同时也保护了用户的浏览体验。91浏览器的安全模式集成了实时恶意网址检测和多层防火墙技术，全方位守护用户的上网安全。',
    },
  ],
};